module.exports = __webpack_public_path__ + "static/media/prettypicture.0121321a.png";